import { render, staticRenderFns } from "./SourcingRequest.vue?vue&type=template&id=0901885b&scoped=true&"
import script from "./SourcingRequest.vue?vue&type=script&lang=js&"
export * from "./SourcingRequest.vue?vue&type=script&lang=js&"
import style0 from "./SourcingRequest.vue?vue&type=style&index=0&id=0901885b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0901885b",
  null
  
)

export default component.exports